import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import Modal   from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function Grades() {
  const [grades,  setGrades]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal,   setModal]   = useState(false);
  const [editing, setEditing] = useState(null);
  const [form,    setForm]    = useState({ grade_number: '', grade_name: '', capacity: 40 });

  const load = () => adminApi.getGrades().then(r => setGrades(r.data.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const openAdd  = () => { setEditing(null); setForm({ grade_number: '', grade_name: '', capacity: 40 }); setModal(true); };
  const openEdit = (g) => { setEditing(g); setForm({ grade_number: g.grade_number, grade_name: g.grade_name || '', capacity: g.capacity || 40 }); setModal(true); };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) await adminApi.updateGrade({ ...form, grade_id: editing.grade_id });
      else         await adminApi.addGrade(form);
      toast.success(editing ? 'Grade updated' : 'Grade added');
      setModal(false); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this grade? This will also remove linked subjects.')) return;
    try { await adminApi.deleteGrade(id); toast.success('Grade deleted'); load(); }
    catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div><h2>Grades</h2><p>Manage school grades / year groups</p></div>
        <button className="sms-btn sms-btn-primary" onClick={openAdd}><FaPlus size={13} /> Add Grade</button>
      </div>

      <div className="sms-card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? <Spinner /> : (
          <table className="sms-table">
            <thead><tr><th>Grade Number</th><th>Grade Name</th><th>Capacity</th><th>Subjects</th><th>Learners</th><th>Actions</th></tr></thead>
            <tbody>
              {grades.map(g => (
                <tr key={g.grade_id}>
                  <td style={{ fontWeight: 600 }}>Grade {g.grade_number}</td>
                  <td>{g.grade_name || '—'}</td>
                  <td>{g.capacity}</td>
                  <td>{g.subject_count}</td>
                  <td>{g.learner_count}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button className="sms-btn sms-btn-outline sms-btn-sm" onClick={() => openEdit(g)}><FaEdit size={12} /></button>
                      <button className="sms-btn sms-btn-danger sms-btn-sm"  onClick={() => handleDelete(g.grade_id)}><FaTrash size={12} /></button>
                    </div>
                  </td>
                </tr>
              ))}
              {grades.length === 0 && <tr><td colSpan="6" style={{ textAlign: 'center', color: '#9ca3af', padding: '40px 0' }}>No grades yet</td></tr>}
            </tbody>
          </table>
        )}
      </div>

      <Modal show={modal} onClose={() => setModal(false)} title={editing ? 'Edit Grade' : 'Add Grade'}>
        <form onSubmit={handleSave}>
          <div style={{ marginBottom: 14 }}>
            <label className="sms-label">Grade Number / Identifier <span style={{ color: '#ef4444' }}>*</span></label>
            <input className="sms-input" value={form.grade_number} onChange={e => setForm({ ...form, grade_number: e.target.value })} required placeholder="e.g. 8, 9, 10, R" />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label className="sms-label">Grade Name (optional)</label>
            <input className="sms-input" value={form.grade_name} onChange={e => setForm({ ...form, grade_name: e.target.value })} placeholder="e.g. Junior Secondary" />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label className="sms-label">Capacity</label>
            <input className="sms-input" type="number" value={form.capacity} onChange={e => setForm({ ...form, capacity: e.target.value })} min="1" />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="submit" className="sms-btn sms-btn-primary">Save</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={() => setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
